
/* injects from baggage-loader */

import { FormSizes } from '../../index.const';

import { genSecureHex } from '../../core/services/secure-random';

export class Form {
    constructor(x, y, angle, size, color){
        this.id  = genSecureHex(8);
        this.x = x;
        this.y = y;
        this.angle = angle;
        this.color = color;
        this.size = size;

        switch (size) {
            case FormSizes.small:
                this.width = 45;
                this.height = 45;
                break;
            case FormSizes.normal:
                this.width = 90;
                this.height = 90;
                break;
            case FormSizes.big:
                this.width = 125;
                this.height = 125;
                break;        
            default:
                break;
        }        
    }    
}


// WEBPACK FOOTER //
// ./src/app/core/models/Form.js